import { api } from "api/api";
import { AxiosError } from "axios";
import MovimentoEstoquePratico from "model/integracao/pratico/MovimentoEstoquePratico";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { getFilters } from "utils/filterUtils";

export default class MovimentoPraticoService{
    
    pesquisar(page: Pageable, filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/integracao/pratico/movimentoEstoque/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    
    reexecutar(movimento: MovimentoEstoquePratico) {
        return new Promise<void>((resolve, reject): void => {
            let url = `/integracao/pratico/movimentoEstoque/reexecutar`;

            api
                .post(url, movimento)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTipoMovimento(tipo: String){
        if(tipo === "E"){
            return "Entrada";
        }
        if(tipo === "S"){
            return "Saída";
        }
        return "";
    }
}